<template>
    <div>
        <div class="container">
            <!-- <Breadcrumb class="my-3" /> -->
            <CommonBreadcrumb class="my-3" /> 
        </div>
        <div class="">
            <EngagementLandingEngagementBanner />
        </div>

        <div class="container_mod mt-md-5 my-5">
            <EngagementLandingCreateYourOwn />
        </div>

        <div class="container_mod style-container mt-md-5 my-5">
         <EngagementLandingShopByStyle />
        </div> 

        <div class="container_mod mt-md-5 my-5">
            <EngagementLandingHandCrafted />
        </div>

        <div class="mt-md-5 my-5">
            <EngagementLandingShopbyShape />
        </div>
        
        <div class="container_mod mt-md-5 my-5">
          <EngagementLandingToiEtMoiBanner />
        </div>
        
        <div class="mt-md-5 my-5">
            <EngagementLandingShopByMetal />
        </div> 

        <!-- <div class="container mt-md-5">
            <div class="padding_block"></div>
            <HomeTestimonialsIndia v-if="$country.is_india" />
            <HomeTestimonials v-else />
        </div> -->

        <!-- <div class="mt-md-5">
            <EngagementLandingEngagmentPicks />
        </div> -->

        <div class="cyo_banner_mod mt-md-5 my-5">
            <EngagementLandingFriendlyService />
        </div> 

        <div class="mt-md-5 my-5">
            <EngagementLandingNoteWorthy />
        </div>

        <div class="container mt-md-5 my-5">
            <!-- <EngagementLandingEngFaq /> -->
            <FaqDynamicFaq  />
        </div>

    </div>
</template>

<script setup>



</script>

<style scoped>
 .container_mod{
    max-width: 1470px;
    width: 100%;
    margin: 0 auto;
}
@media(max-width: 1470px){
    .container_mod{
        width: 80%;
    }
   
}
@media(max-width: 1250px){
    .container_mod{
        width: 90%;
    }
}

@media(max-width: 767px){
    .container_mod.style-container{
        width: 100%;
    }
}



</style>